<div class="card">
    <ng-container *ngFor="let data of templateData; index as x">
        <!-- image sections -->
        <div #ImageSection *ngIf="data.sectionType === 'image'" class="section image-section" [ngStyle]="{'height.px': data.sectionHeight}" [attr.section]="x">
            <img src="{{data.section.imageUrl}}" [ngStyle]="{'height.px': data.sectionHeight}" />

            <!-- tag -->
            <ng-container *ngIf="data.section.tag.isValid">
                <div class="tag" lm-field-style [isTag]="true" [fieldStyle]="data.section.tag.style">
                    <span class="tag-content">{{data.section.tag.tagValue}}</span>
                </div>
            </ng-container>
        </div>

        <!-- title sections -->
        <div #TitleSection *ngIf="data.sectionType === 'title'"
             class="section title-section"
             [ngStyle]="{ 'height.px': data.sectionHeight }"
             [attr.section]="x"
             soho-tooltip [title]="data.section.displayValue"
        >
            <ng-container *ngIf="data.section.navigationParams; else NotALink">
                <h3 [ngStyle]="{'-webkit-line-clamp' : data.section.lines ? data.section.lines : 1 }">
                    <a href=""
                       class="hyperlink"
                       [ngStyle]="{'-webkit-line-clamp' : data.section.lines ? data.section.lines : 1 }"
                       (click)="onUILinkEvent(data.section.navigationParams)">
                        {{data.section.displayValue}}
                    </a>
                </h3>
            </ng-container>
            <ng-template #NotALink>
                <h3 [ngStyle]="{'-webkit-line-clamp' : data.section.lines ? data.section.lines : 1 }">{{data.section.displayValue}}</h3>
            </ng-template>
        </div>

        <!-- row sections -->
        <div *ngIf="data.sectionType === 'row'" class="section row-section" [style.height.px]="data.section.fields[0].height" [attr.section]="x">
            <ng-container *ngFor="let field of data.section?.fields">
                <ng-container *ngIf="!field.actionReference">
                    <ng-container *ngTemplateOutlet="Fields; context: {field: field}"></ng-container>
                </ng-container>
                <ng-container *ngIf="field.actionReference">
                    <ng-container *ngTemplateOutlet="Actions; context: {action: field}"></ng-container>
                </ng-container>
            </ng-container>
        </div>

        <!-- field sections -->
        <div *ngIf="data.sectionType === 'field'" class="section field-section" [style.height.px]="data.sectionHeight" [attr.section]="x">
            <div *ngFor="let field of data.section?.fields; index as i" [attr.row]="i">
                <ng-container *ngTemplateOutlet="Fields; context: {field: field}">
                    <p *ngIf="field.value">{{field.value}}</p>
                </ng-container>
            </div>
        </div>

        <!-- action sections -->
        <div *ngIf="data.sectionType === 'action'" class="section action-section" [attr.section]="x">
            <div class="left-section">
                <ng-container *ngFor="let action of data.section?.actions.leftSection">
                    <ng-container  *ngTemplateOutlet="CheckControl; context: {checkcontrol: action}"></ng-container>
                </ng-container>
            </div>
            <div class="right-section">
                <ng-container *ngFor="let action of data.section?.actions.rightSection">
                    <ng-container  *ngTemplateOutlet="Actions; context: {action: action}"></ng-container>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>

<!-- field template -->
<ng-template #Fields let-field="field">
    <div class="sectioned-card-field" soho-tooltip [content]="field.displayValue">
        <label *ngIf="field.label">{{field.label}}:</label>

        <!-- rating field -->
        <ng-container *ngIf="field.displayAsRating">
            <div soho-rating class="is-readonly">
                <ng-container *ngFor="let option of field.ratingOptions; index as i">
                    <input type="radio" name="rating_options" id="{{option.id}}" [ngClass]="option.class" [attr.disabled]="true">
                    <label for="{{option.id}}">
                        <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                            <use [attr.xlink:href]="option.href"></use>
                        </svg>
                        <span class="audible">{{option.label}}</span>
                    </label>
                </ng-container>
            </div>
        </ng-container>

        <!-- standard field or form text -->
        <ng-container *ngIf="field.isFormText || field.isField && !field.displayAsRating">
            <p class="sectioned-card-field-text" [ngStyle]="{'-webkit-line-clamp': field.lines}">{{field.displayValue}}</p>
        </ng-container>
    </div>
</ng-template>

<!-- check control template -->
<ng-template #CheckControl let-checkcontrol="checkcontrol">
<!--    <ng-container *ngIf="checkcontrol.displayAsBox">-->
<!--        <input soho-checkbox type="checkbox" aria-hidden="true" role="presentation" class="checkbox" tabindex="0">-->
<!--        <label class="checkbox-label"><span class="audible"></span></label>-->
<!--    </ng-container>-->
<!--    <div *ngIf="checkcontrol.displayAsSwitch" class="switch">-->
<!--        <input soho-checkbox class="switch">-->
<!--        <label soho-label [forCheckBox]="true"><span class="audible"></span></label>-->
<!--    </div>-->
<!--    <ng-container *ngIf="checkcontrol.displayAsStar">-->
<!--        <button soho-button="favorite"></button>-->
<!--    </ng-container>-->
</ng-template>

<!-- actions template -->
<ng-template  #Actions let-action="action">
    <!-- icon only -->
    <ng-container *ngIf="action.isIconOnly; else NotIconButton">
        <button
                *ngIf="action.isIconOnly"
                soho-button="icon" [isToggle]="action?.isToggle" [isTogglePressed]="action.state?.isPressed" [icon]="action.icon"
                soho-tooltip [title]="action.displayTooltip ? action.actionReference?.label || action.actionReference?.tooltip : null"
                class="btn lm-icon-button"
                lm-field-style [fieldStyle]="action?.fieldStyle"
                [attr.data-action-reference]="stringifyJson(action?.actionReference)"
                [ngClass]="{'lm-missing-soho-icon': !action.icon}"
                (click)="onActionClicked($event)"
        >
            <span *ngIf="action.icon">{{action.actionReference?.label}}</span>
            <ng-container>
                <!-- Need nbsp, if span is empty then ids-enterprise css will hide it -->
                <span *ngIf="!action.icon" [ngStyle]="{'background-image': 'url(' + action.iconUrl + ')'}">&nbsp;</span>
                <span class="audible">{{action.actionReference?.label}}</span>
            </ng-container>
        </button>
    </ng-container>
    <ng-template #NotIconButton>
        <!-- httpUrl (external link)-->
        <a *ngIf="action.isOpenExternal"
           [ngClass]="{'btn hyperlink': action.isDisplayAsLink, 'btn': !action.isDisplayAsLink}"
           [attr.href]="action.httpUrl"
           lm-field-style [fieldStyle]="action?.fieldStyle"
           target="_blank"
           (click)="external(action, $event)"
        >
            <span>{{action.actionReference?.label}}</span>
        </a>

        <!-- display buttons as links -->
        <button *ngIf="action.isDisplayAsLink && !action.isOpenExternal"
                class="btn hyperlink"
                lm-field-style [fieldStyle]="action?.fieldStyle"
                [attr.data-action-reference]="stringifyJson(action?.actionReference)"
                (click)="onActionClicked($event)"
        >
            <span>{{action.actionReference?.label}}</span>
        </button>

        <!-- action buttons -->
        <button *ngIf="!action.isDisplayAsLink && !action.isOpenExternal"
                class="btn"
                [ngClass]="{'lm-is-primary': action?.isPrimary}"
                lm-field-style [fieldStyle]="action?.fieldStyle"
                [attr.data-action-reference]="stringifyJson(action?.actionReference)"
                (click)="onActionClicked($event)"
        >
            <span>{{action.actionReference?.label}}</span>
        </button>
    </ng-template>
</ng-template>